import Seo from "@/lib/Seo";
import { FadeUp } from "@/lib/motion";
import { REGIONS } from "@/data/content";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function ServiceArea() {
  return (
    <div className="pt-[72px]">
      <Seo
        title="Service Area — Southern California Weddings | Marble & Veil"
        description="Marble & Veil serves San Diego coastal communities, North County, Temecula, Murrieta, Winchester, Riverside, Orange County, and Los Angeles — availability scoped by date, scope, staffing, and travel."
        path="/service-area"
      />
      <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
        <Breadcrumbs trail={[["Home", "/"], ["Service Area"]]} />
        <FadeUp>
          <h1 className="mt-6 font-display text-5xl leading-[1.05] text-ink sm:text-6xl">Where We Work</h1>
          <p className="mt-5 max-w-2xl leading-relaxed text-smoke">
            Marble &amp; Veil serves celebrations across Southern California, from coastal San Diego
            through Orange County and Los Angeles, plus the Temecula Valley and inland communities.
            Whether we can join your date depends on the event's scope, staffing, travel, and setup —
            it is confirmed personally, in your proposal.
          </p>
        </FadeUp>

        <div className="mt-16 grid gap-px bg-ink/10 sm:grid-cols-2 lg:grid-cols-3">
          {REGIONS.map((r, i) => (
            <FadeUp key={r.name} delay={(i % 3) * 0.08} className="bg-ivory">
              <div className="flex h-full flex-col p-8" data-testid={`region-${r.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <span className="font-display text-3xl italic text-olive">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="mt-4 font-display text-2xl text-ink">{r.name}</h2>
                <p className="mt-3 text-sm leading-relaxed text-smoke">{r.text}</p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.1}>
          <div className="mt-16 border border-ink/10 bg-parch p-8" data-testid="service-area-honesty-note">
            <h2 className="font-display text-2xl text-ink">An honest note</h2>
            <ul className="mt-4 space-y-2 text-sm leading-relaxed text-smoke">
              <li>We do not claim offices in these cities, venue partnerships, free delivery, or fixed travel fees.</li>
              <li>Availability depends on your date, the event's scope, staffing, travel, and setup time.</li>
              <li>Product shipping for goods-only orders is arranged separately from event services and confirmed in your proposal.</li>
              <li>If your celebration sits just outside the areas above, ask — we will tell you plainly if we can make it work.</li>
            </ul>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
